<div class="metrics-dashboard-main">
    <div class="metrics-dashboard-content">
        <cv-metrics-toolbar (viewMode)="onViewMetricsViewChange($event)" (filtersChange)="onFiltersChange($event)" ></cv-metrics-toolbar>
        <div class="metrics-dashboard-elements scrollable scrollable-component">
            <div class="metrics-charts" *ngIf="selectedView === 'Graph'">
                <cv-weekly-chart [type]="'bar'" [data]="totalReviewedChart.data" [title]="'Total Reviewed per Week'"></cv-weekly-chart>
                <cv-weekly-chart [type]="'bar'" [data]="rejectedChart.data" [options]="rejectedChart.options"  [title]="'Rejected by QC Reviewer & Client'"></cv-weekly-chart>
                <cv-weekly-chart [type]="'line'" [data]="avgTimesChart.data" [title]="'Average Times (mins)'"></cv-weekly-chart>
                <cv-weekly-chart [type]="'line'" [data]="revisionRateChart.data" [title]="'Revision Rates (%)'"></cv-weekly-chart>
              </div>
            <div class="metrics-table" *ngIf="selectedView === 'Grid'">
                <cv-metrics-table></cv-metrics-table>
            </div>
        </div>
    </div>
</div>